<template>
    <div class="authentice">
        <div v-if="formData.pass_status >= 1" class="card user">
            <div id="authentice_title" class="title">实名信息</div>
            <veui-button
                v-if="formData.pass_status === 1"
                class="modify-btn"
                ui="primary"
                @click="handleGotoAuth(formData.pass_status + 1)"
            >刷脸认证</veui-button>
            <veui-form :data="formData" class="id-card">
                <veui-field
                    name="name"
                    label="姓名"
                >
                    <div>{{ formData.pass_name }} <span class="name-pass">已认证</span></div>
                </veui-field>
                <veui-field
                    name="code"
                    label="身份证号"
                    style="margin-bottom: 0;"
                >
                    <div>{{ formData.cert_code }}  <span class="name-pass">已认证</span></div>
                </veui-field>
            </veui-form>
        </div>
        <div v-if="formData.pass_status < 1" class="user">
            <div id="authentice_title" class="title">实名认证</div>
            <veui-button
                class="modify-btn"
                ui="primary"
                @click="handleGotoAuth(formData.pass_status + 1)"
            >实名认证</veui-button>
            <!-- 未认证 -->
            <veui-form :data="formData">
                <veui-field
                    name="name"
                    label="姓名"
                >
                    <div>无<span class="name-pass-not">未认证</span></div>
                </veui-field>
                <veui-field
                    name="code"
                    label="身份证号"
                >
                    <div>无<span class="name-pass-not">未认证</span></div>
                </veui-field>
            </veui-form>
        </div>

        <!-- 认证信息完善引导 -->
        <authenticationGuideCard v-if="!isModify" @clickEdit="clickEdit"/>

        <div id="practice-info" class="card">
            <!-- 下载APP/关注服务号引导条幅（常驻） -->
            <img
                class="download-app-banner"
                src="https://lvlin-fe-saas.cdn.bcebos.com/banner/downloa-wxchat-banner.png"
                alt="下载APP或关注服务号，获取更多权益"
            >
            <!-- 信息认证结果 -->
            <veui-alert
                v-if="!isModify && info_status !== '0'
                    && info_status !== '10'"
                :status="statusType.value"
                :title="statusType.label"
            >
                <!-- <template #extra>
                    <veui-button
                        v-if="!isSubPushTip"
                        class="sub-tip"
                        ui="basic"
                        @click="handleSubPushTip(1)"
                    >订阅审核结果通知</veui-button>
                    <veui-button
                        v-else
                        ui="primary"
                        class="sub-tip-not"
                        @click="showCanclePushTip = true"
                    >取消订阅审核结果通知</veui-button>
                </template> -->
            </veui-alert>
            <div class="title">执业认证
            </div>
            <veui-form
                ref="form"
                :validators="validators"
                :data="formData"
                class="form"
                :class="[isModify ? 'is-edit' : 'isViewModel']"
            >
                <veui-field
                    name="personal_avatar"
                    field="personal_avatar"
                    label="个人头像"
                    :style="{'margin-bottom': '36px'}"
                    :rules="[{name: 'required', value: true, message: '请上传'}]"
                >
                    <cropper-avator-ai
                        v-if="isModify"
                        ref="cropperAvatorAi"
                        :class="{'ispass': !isModify}"
                        item="case_pic"
                        field="case_pic"
                        :max-size="5120"
                        :url="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                        :is-not-essential="true"
                        :img-src="!formData.personal_avatar ? '' : formData.personal_avatar"
                        @upload-suc="uploadSuc"
                    ></cropper-avator-ai>
                    <div v-if="!isModify && formData.personal_avatar" class="img-wrapper">
                        <img
                            class="viewimg"
                            :src="formData.personal_avatar"
                            alt=""
                        >
                    </div>
                    <div v-if="!isModify && !formData.personal_avatar">未上传</div>
                    <div v-if="isModify" class="diagram">
                        <div class="notify">照片标准示例</div>
                        <img
                            src="https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-biaozhun.png"
                            alt=""
                        >
                    </div>
                    <div v-if="isModify" class="decs">
                        <p>1.请参考示意图上传本人<strong class="red">近期正面、免冠</strong>头像</p>
                        <p>2.照片5M以内，支持jpeg/jpg/bmp/png格式</p>
                        <p>3.您的头像将在百度搜索中展示给用户，请参考标准调整人像位置和像素清晰度</p>
                        <p class="example">照片标准示例</p>
                        <div
                            v-if="isShowAiAvatarsBtn"
                            v-visually="{
                                serverId: 20062,
                                area: 'dz-ai-avatar',
                                isNotRepeat: true,
                            }"
                            class="show-avatar-btn"
                            @click="showAvatarChooseModal"
                        >
                            <span class="show-avatar-btn-icon"></span>
                            AI定制专属职业形象</div>
                        <veui-popover
                            target="avatar-example"
                            position="bottom"
                            overlay-class="avatar-example"
                        >
                            <div class="example-title">职业形象照审核要求</div>
                            <p class="example-item">1. 请参考示意图上传本人近期正面、免冠头像</p>
                            <p class="example-item">2. 照片5M以内，支持jpeg/jpg/bmp/png格式</p>
                            <p class="example-item">3. 您的头像将在百度搜索中展示给用户，请参考标准调整人像位置和像素清晰度</p>
                            <div class="correct-avatar">
                                <div class="icon"></div>
                                <div class="label">
                                    符合标准的照片范例
                                </div>
                            </div>
                            <div class="avatar-box">
                                <div class="boy-icon"></div>
                                <div class="girl-icon"></div>
                            </div>
                            <div class="error-avatar">
                                <div class="icon"></div>
                                <div class="label">
                                    不符合标准的情况
                                </div>
                            </div>
                            <div class="avatar-box not-standardized">
                                <div
                                    v-for="item, index in avatarList"
                                    :key="index"
                                >
                                    <div
                                        class="avatar-icon"
                                        :style="{backgroundImage: `url(${item.pic})`}"
                                    ></div>
                                    <div class="avatar-text">{{ item.text }}</div>
                                </div>
                            </div>
                        </veui-popover>
                    </div>
                </veui-field>
                <veui-fieldset
                    class="identity honorary veui-field-required"
                    label="执业证"
                    :class="[isModify ? 'mb30' : 'mb26']"
                    required
                >
                    <veui-field
                        name="register_image"
                        field="register_image"
                    >
                        <div v-if="isModify">
                            <div class="register-image-list">
                                <div class="mr12">
                                    <veui-uploader
                                        class="register"
                                        :value="!formData.register_image_home ? null :
                                            {'src': formData.register_image_home, key: 'register_image_home'}"
                                        :max-count="1"
                                        :class="{'ispass': !isModify}"
                                        :accept="imageAccept"
                                        max-size="5120kb"
                                        :convert-response="(data) => convertResponse(data, 'register_image_home')"
                                        type="image"
                                        :action="`${url}&bucketName=law_smart&storeDir=register_image&ajax=true`"
                                        ui="s"
                                        @change="res => uploaderChange(res, 'register_image_home')"
                                    >
                                    </veui-uploader>
                                    <div class="register-image-tips">首页</div>
                                    <div v-if="showRegisterError" class="register-error">请上传</div>
                                </div>
                                <div class="mr12">
                                    <veui-uploader
                                        class="register"
                                        :value="!formData.register_image_record ? null :
                                            {'src': formData.register_image_record, key: 'register_image_record'}"
                                        :max-count="1"
                                        :class="{'ispass': !isModify, 'border-color-red': hasError}"
                                        :accept="imageAccept"
                                        max-size="5120kb"
                                        :convert-response="(data) => convertResponse(data, 'register_image_record')"
                                        type="image"
                                        :action="`${url}&bucketName=law_smart&storeDir=register_image&ajax=true`"
                                        ui="s"
                                        @change="res => uploaderChange(res, 'register_image_record')"
                                    >
                                    </veui-uploader>
                                    <div :class="['register-image-tips', hasError && 'text-color-red']">有效期内备案页</div>
                                    <div v-if="showRegisterRecordError" class="register-error">请上传</div>
                                </div>
                            </div>
                            <div class="register-image-list-other">
                                <veui-uploader
                                    v-model="formData.register_image_other"
                                    :max-count="8"
                                    :class="{'ispass': !isModify}"
                                    :accept="imageAccept"
                                    max-size="5120kb"
                                    :convert-response="(data) => convertResponse(data, 'register_image_other')"
                                    type="image"
                                    :action="`${url}&bucketName=law_smart&storeDir=register_image&ajax=true`"
                                    ui="s"
                                    help="其他"
                                    help-position="bottom"
                                >
                                </veui-uploader>
                            </div>
                        </div>
                        <div
                            v-if="!isModify && formData.register_image && formData.register_image.length > 0"
                            class="licence-wrapper"
                        >
                            <div v-for="(item, index) in formData.register_image" :key="index">
                                <div class="img-wrapper mult">
                                    <img
                                        class="viewimg" :src="item"
                                        alt=""
                                    >
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="!isModify && (!formData.register_image || formData.register_image.length === 0)"
                            class="not-upload"
                        >
                            未上传
                        </div>
                        <div v-if="isModify" class="decs licencedecs">
                            <p>1、请上传执业证的<strong class="red">首页</strong>和<strong class="red">有效期内的备案页</strong></p>
                            <p>2、要求照片清晰可看出<strong class="red">执业证号</strong>，<strong class="red">姓名</strong>
                                和<strong class="red">身份证号</strong></p>
                            <p>3、照片5M以内，支持jpg/png/jpeg/gif/wbmp/xbm格式</p>
                            <p>4、执业证图片不会展示在律师主页</p>
                            <div class="decs-tips">
                                <p>*若因更换证件缺失备案页，请补充上传老证件的复印件，手写“与原件一致”并签名</p>
                                <p>*若在中国法律服务网等官方网站上核实不到律师信息，还需补充律师当前律所的在职证明，
                                    包含<strong class="red">姓名、执业证号、身份证号、律所公章</strong></p>
                            </div>
                        </div>
                    </veui-field>
                </veui-fieldset>
                <veui-fieldset
                    class="identity veui-field-required id-card-info"
                    label="身份证"
                    required
                    :class="[isModify ? 'mb30' : 'mb24']"
                >
                    <veui-field
                        name="identity_head_image"
                        field="identity_head_image"
                        :rules="[{name: 'required', value: true, message: '请上传'}]"
                    >
                        <div
                            v-if="isModify"
                            class="identity-image"
                        >
                            <veui-uploader
                                class="portrait"
                                :class="{'ispass': !isModify}"
                                :max-count="1"
                                :accept="imageAccept"
                                max-size="5120kb"
                                :value="!formData.identity_head_image ? null :
                                    {'src': formData.identity_head_image, key: 'identity_head_image'}"
                                :convert-response="(data) => convertResponse(data, 'identity_head_image')"
                                type="image"
                                :action="`${url}&bucketName=law_smart&storeDir=identity_head_image&ajax=true`"
                                ui="s"
                                @change="res => uploaderChange(res, 'identity_head_image')"
                            >
                            </veui-uploader>
                            <div class="identity-image-tips">身份证人像面</div>
                        </div>
                        <div v-else-if="formData.identity_head_image" class="img-wrapper">
                            <img class="viewimg" :src="formData.identity_head_image">
                        </div>
                        <div v-else class="not-upload">
                            未上传
                        </div>
                    </veui-field>
                    <veui-field
                        name="identity_national_image"
                        :class="{'ml12': isModify}"
                        field="identity_national_image"
                        :rules="[{name: 'required', value: true, message: '请上传'}]"
                    >
                        <div
                            v-if="isModify"
                            class="identity-image"
                        >
                            <veui-uploader
                                class="emblem"
                                name="file"
                                max-size="5120kb"
                                :accept="imageAccept"
                                :class="{'ispass': !isModify}"
                                :value="!formData.identity_national_image ?
                                    null : ({'src': formData.identity_national_image, key: 'identity_national_image'})"
                                :max-count="1"
                                :convert-response="(data) => convertResponse(data, 'identity_national_image')"
                                type="image"
                                :action="`${url}&bucketName=law_smart&storeDir=identity_national_image&ajax=true`"
                                ui="s"
                                @change="res => uploaderChange(res, 'identity_national_image')"
                            >
                            </veui-uploader>
                            <div class="identity-image-tips">身份证国徽面</div>
                        </div>
                        <div v-else-if="formData.identity_national_image" class="img-wrapper">
                            <img class="viewimg" :src="formData.identity_national_image">
                        </div>
                        <div v-if="isModify" class="decs">
                            <p>1.请参照示例拍照上传身份照片，确保证件信息清晰可见</p>
                            <p>2.照片5M以内，支持jpg/jpeg/png格式</p>
                            <p>3.身份证照片不会展示在律师主页</p>
                        </div>
                    </veui-field>
                </veui-fieldset>
                <div v-if="isModify" class="blue-tips">
                    <div class="icon"></div>
                    <div>以下字段上传图片后，自动识别输入</div>
                </div>
                <div class="text-info">
                    <veui-field
                        name="register_id"
                        field="register_id"
                        label="执业证号"
                        class="register-id-field text"
                        :class="[isModify ? 'mb30' : 'mb18']"
                        :rules="[{name: 'required', value: true}]"
                    >
                        <veui-input
                            v-if="isModify" v-model="formData.register_id"
                            placeholder="请输入律师执业证号或实习证号"
                        />
                        <div v-else>{{ formData.register_id }}</div>
                    </veui-field>
                    <veui-field
                        name="register_years"
                        field="register_years"
                        label="执业年限"
                        class="register-years-field text"
                        :class="[isModify ? 'mb30' : 'mb18']"
                        :rules="[{name: 'required', value: true}]"
                    >
                        <veui-number-input
                            v-if="isModify"
                            v-model="formData.register_years"
                            placeholder="请输入您的从业年限"
                        /><span v-if="isModify" class="formname">年</span>
                        <div v-if="!isModify">{{ formData.register_years }}年</div>
                        <span v-if="isModify" class="desc">计算说明：执业年限以<strong
                            class="red"
                        >实际已满年数</strong>为准计算（如：两年半计为两年），此信息不可擅自修改，以免影响审核进度</span>
                    </veui-field>
                    <veui-field
                        name="show_register_years"
                        field="show_register_years"
                        label="是否将执业年限信息展示在搜索结果中"
                        class="show_register_years text"
                        :class="[isModify ? '' : 'mb18']"
                        :rules="[{name: 'required', value: true}]"
                    >
                        <veui-radio-group
                            v-if="isModify"
                            v-model="formData.show_register_years"
                            :value="formData.show_register_years"
                            :items="licenses"
                            @change="showYearsChange"
                        />
                        <div v-else>{{ formData.show_register_years ? '是' : '否' }}</div>
                    </veui-field>
                    <veui-field
                        name="register_law_firm"
                        field="register_law_firm"
                        label="执业律所"
                        class="text"
                        :class="[isModify ? 'mb30' : 'mb18']"
                        :rules="[{name: 'required', value: true}]"
                    >
                        <veui-input
                            v-if="isModify" v-model="formData.register_law_firm"
                            placeholder="请输入您执业证上的执业律所名称"
                        />
                        <div v-else>{{ formData.register_law_firm }}</div>
                    </veui-field>
                    <veui-field
                        name="mobile_number"
                        field="mobile_number"
                        label="执业手机"
                        class="text"
                        :class="[isModify ? 'mb30' : 'mb18']"
                        :rules="[{name: 'required', value: true}]"
                    >
                        <veui-number-input
                            v-if="isModify"
                            v-model="formData.mobile_number"
                            placeholder="请输入您的执业手机号"
                        />
                        <div v-else>{{ formData.mobile_number }}</div>
                    </veui-field>
                    <veui-field
                        label="从业地区"
                        field="register_region"
                        name="register_region"
                        class="text"
                        :class="[isModify ? 'mb30' : 'mb18']"
                        :rules="[{name: 'required', value: true, message: '请选择'}]"
                    >
                        <Cascader
                            v-show="isModify"
                            v-model="formData.register_region"
                            :data="regionOption"
                            clearable
                        >
                        </Cascader>
                        <div v-show="!isModify">{{ formData.city }}</div>
                        <div v-if="isModify" class="decs">
                            <span
                                class="form-href-terms form-city"
                                pointer
                                @click.stop="gotoAgreement('city')"
                            >《城市等级列表》</span>
                        </div>
                    </veui-field>
                    <veui-field
                        id="register_domain"
                        label="擅长领域"
                        data-stat-ignore
                        name="register_domain"
                        field="register_domain"
                        :style="{'margin-bottom': isModify ? '24px' : '0px'}"
                        class="register-domain text"
                        :rules="[{name: 'required', value: true, message: '请选择擅长领域'}]"
                    >
                        <div class="domain-select-wrap">
                            <veui-select
                                v-if="isModify"
                                ref="veuiselect"
                                v-model="formData.register_domain"
                                data-stat-ignore
                                clearable
                                multiple
                            >
                                <veui-option-group
                                    v-for="(item, index) in doaminOption"
                                    :key="index"
                                    :label="item.name"
                                    position="popup"
                                >
                                    <veui-option
                                        v-for="item in item.children"
                                        :key="item.id"
                                        :value="item.name"
                                        :label="item.name"
                                    />
                                </veui-option-group>
                            </veui-select>
                            <div v-else>{{ formData.register_domain && formData.register_domain.join(',') }}</div>
                            <p v-if="isModify && missingDomainCount > 0" class="domain-error-tip">
                                <veui-icon class="tip-icon" name="info-circle-solid"/>
                                您还有{{ missingDomainCount }}个擅长领域未选，补全可获更多流量
                            </p>
                        </div>
                        <div v-if="isModify" class="decs">
                            <p>1.您最多只能筛选{{ lawyerFieldsNum }}个领域标识</p>
                            <p>2.领域若有更改，将为您同步更新律师智能体擅长领域并重新提交智能<br>体审核申请</p>
                        </div>
                    </veui-field>
                </div>
                <p v-if="isModify" class="form-tips">提交后将根据您所选择的擅长领域生成默认的个人简介，可在【个人展示信息】信息审核通过后进行修改！</p>
            </veui-form>
        </div>

        <!-- 个人信息 -->
        <div
            v-if="formData.first_approve === 1"
            id="personal-info"
            class="card"
        >
            <div class="title">个人展示信息</div>
            <veui-form
                ref="personalForm"
                :validators="presonalValidators"
                :data="formData"
                class="form"
                :class="[isModify ? 'is-edit' : 'isViewModel']"
            >
                <veui-field
                    name="lawyer_position"
                    field="lawyer_position"
                    label="律师职务"
                    class="lawyer-position text"
                    :style="{'margin-bottom': isModify ? '28px' : '24px'}"
                >
                    <veui-select
                        v-if="isModify"
                        v-model="formData.lawyer_position"
                        placeholder="请选择"
                        data-stat-ignore
                        clearable
                    >
                        <veui-option
                            v-for="(item, index) in positionOption"
                            :key="index"
                            :label="item"
                            :value="item"
                        >
                        </veui-option>
                    </veui-select>
                    <div v-else>{{ formData.lawyer_position || '无' }}</div>
                    <span v-if="isModify" class="formname"></span>
                    <span v-if="isModify && formData.lawyer_position">是否将律师职务信息展示在搜索结果中：</span>
                    <veui-radio-group
                        v-if="isModify && formData.lawyer_position"
                        v-model="formData.show_lawyer_position"
                        :value="formData.show_lawyer_position"
                        :items="licenses"
                        @change="showYearsChange"
                    />
                </veui-field>
                <veui-fieldset
                    v-if="formData.lawyer_position && formData.lawyer_position !== '专职律师'"
                    class="identity veui-field-required position-img"
                    label="职务证明"
                    :style="{'margin-bottom': isModify ? '44px' : '24px'}"
                    required
                >
                    <veui-field
                        name="lawyer_position_image"
                        field="lawyer_position_image"
                        :rules="[{name: 'required', value: true, message: '请上传'}]"
                    >
                        <veui-uploader
                            v-if="isModify"
                            class="portrait"
                            :class="{'ispass': !isModify}"
                            :max-count="1"
                            :accept="imageAccept"
                            max-size="5120kb"
                            :value="!formData.lawyer_position_image ? null : {'src': formData.lawyer_position_image}"
                            :convert-response="(data) => convertResponse(data, 'lawyer_position_image')"
                            type="image"
                            :action="`${url}&bucketName=law_smart&storeDir=identity_head_image&ajax=true`"
                            ui="s"
                            @change="res => uploaderChange(res, 'lawyer_position_image')"
                        >
                        </veui-uploader>
                        <div v-else-if="formData.lawyer_position_image" class="img-wrapper">
                            <img class="viewimg" :src="formData.lawyer_position_image">
                        </div>
                        <div v-else class="not-upload">
                            未上传
                        </div>
                        <span
                            v-if="isModify"
                            class="decs"
                            :style="{width: '680px'}"
                        >
                            <span>1.若选择专职律师， 请上传律师执业证中证明专职身份的页面<br/></span>
                            <span>2.若选择主任/合伙人/高级合伙人律师，请上传相关官方证明（如律所官网职务截图或律所出具的职务证明）<br/></span>
                            <span>3.律师职位与执业年限信息，请至少填写一项<br/></span>
                            <span>4.您上传的职务证明图片仅用于审核，不会展示在律师主页</span>
                        </span>
                    </veui-field>
                </veui-fieldset>
                <veui-field
                    name="register_philosophy"
                    field="register_philosophy"
                    ui="m"
                    label="执业理念"
                    class="register-philosophy text"
                    :class="[isModify ? 'mb30' : 'mb18']"
                >
                    <veui-input
                        v-if="isModify"
                        v-model="formData.register_philosophy"
                        maxlength="25"
                        placeholder="请输入您的执业理念"
                    />
                    <div v-else>
                        {{ formData.register_philosophy || '未填写' }}
                    </div>
                    <span v-if="isModify" class="decs">
                        <span>1.简介不得出现联系方式，具体涉案金额<br/></span>
                        <span>2.执业理念需要积极正向，不得出现违规内容<br/></span>
                    </span>
                </veui-field>
                <veui-field
                    class="personal-intro"
                    name="personal_intro"
                    field="personal_intro"
                    ui="m"
                    label="律师简介"
                    :style="{'margin-bottom': isModify ? '36px' : '20px'}"
                    :rules="[{name: 'required', value: true}]"
                >
                    <div v-if="isModify">
                        <veui-textarea
                            v-model="formData.personal_intro"
                            class="textarea"
                            placeholder="请输入个人简介，20-500字符；范例：X律师执业以来，
                            参与处理了许多的民商事案件、刑事辩护案件，积累了丰富的办案经验，为当事人争取最大的合法权益。"
                            show-word-limit
                        />
                        <span class="decs">
                            <span>1.若您的简介中涉及您的过往完结案例，请在下方上传相关判决书证明<br/></span>
                            <span class="pa12">图片，原件/复印件均可（复印件需要手写”与原件一致“并签名）<br/></span>
                            <span class="pa12">2.若您的简介中介绍了您的身份，比如某具体公司的法律顾问，某官<br/></span>
                            <span class="pa12">方协会委员等，需要上传对应的扣章证明文件<br/></span>
                            <span class="pa12">3.简介不得出现联系方式，具体涉案金额<br/></span>
                            <span class="pa12">4.<span class="decs-active">为简化您的审核流程，请简要描述即可<br/></span></span>
                            <span class="pa12">5.证明图片不会展示在律师主页</span>
                        </span>
                    </div>
                    <div v-if="!isModify" class="intro">
                        {{ formData.personal_intro }}
                    </div>
                    <div v-if="isModify" class="personal_intro-assist">
                        <veui-uploader
                            :class="{'ispass': !isModify}"
                            :max-count="20"
                            :accept="imageAccept"
                            max-size="5120kb"
                            :convert-response="(data) => convertResponse(data, 'personal_assist_licence')"
                            type="image"
                            :action="`${url}&bucketName=law_smart&storeDir=personal_assist_licence&ajax=true`"
                            ui="s"
                            :value="formData.personal_assist_licence"
                            @change="res => uploaderChange(res, 'personal_assist_licence')"
                        >
                        </veui-uploader>
                    </div>
                    <div
                        v-if="!isModify && formData.personal_assist_licence &&
                            formData.personal_assist_licence.length > 0"
                        class="licence-wrapper"
                    >
                        <div v-for="(item, index) in formData.personal_assist_licence" :key="index">
                            <div class="img-wrapper mult">
                                <img
                                    class="viewimg"
                                    :src="item.src"
                                    alt=""
                                >
                            </div>
                        </div>
                        <div v-if="!formData.personal_assist_licence && !isModify">
                            无
                        </div>
                    </div>
                </veui-field>
                <veui-field
                    name="office_address"
                    label="办公地址"
                    class="text"
                    :class="[isModify ? 'mb30' : 'mb18']"
                >
                    <veui-input
                        v-if="isModify"
                        v-model="formData.office_address"
                        placeholder="请输入您的律师地址"
                    />
                    <div v-else>
                        {{ formData.office_address || '无' }}
                    </div>
                </veui-field>
                <veui-field
                    name="graduated_school"
                    label="毕业院校"
                    class="text"
                    :style="{'margin-bottom': isModify ? '30px' : '24px'}"
                >
                    <veui-input
                        v-if="isModify"
                        v-model="formData.graduated_school"
                        placeholder="请输入您的最高毕业院校"
                    />
                    <div v-else>
                        {{ formData.graduated_school || '无' }}
                    </div>
                </veui-field>
                <veui-field
                    name="graduated_license"
                    class="graduated-license"
                    label="毕业证书"
                    :class="{'text': !formData.graduated_license || !formData.graduated_license.length}"
                    :style="{'margin-bottom': isModify ? '30px' : '12px'}"
                >
                    <veui-uploader
                        v-if="isModify"
                        :class="{'ispass': !isModify}"
                        :accept="imageAccept"
                        max-size="5120kb"
                        :max-count="6"
                        :convert-response="(data) => convertResponse(data, 'graduated_license')"
                        type="image"
                        :action="`${url}&bucketName=law_smart&storeDir=graduated_license&ajax=true`"
                        ui="s"
                        :value="formData.graduated_license"
                        @change="res => uploaderChange(res, 'graduated_license')"
                    >
                    </veui-uploader>
                    <div
                        v-if="!isModify && formData.graduated_license && formData.graduated_license.length > 0"
                        class="licence-wrapper"
                    >
                        <div v-for="(item, index) in formData.graduated_license" :key="index">
                            <div class="img-wrapper mult">
                                <img class="viewimg" :src="item.src">
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="(!formData.graduated_license || formData.graduated_license.length === 0) && !isModify"
                        class="not-upload"
                    >
                        未上传
                    </div>
                    <span v-if="isModify" class="decs">
                        <span>1.要求照片清晰可见<br/></span>
                        <span>2.照片5M以下，支持jpg/jpeg/png格式<br/></span>
                        <span>3.请上传与您毕业院校对应的毕业证书（扣章）<br/></span>
                        <span>4.毕业证书图片不会展示在律师主页</span>
                    </span>
                </veui-field>
                <veui-field
                    name="graduated_school"
                    label="学历"
                    :class="[isModify ? 'mb30' : 'mb18']"
                >
                    <veui-select
                        v-if="isModify"
                        v-model="formData.qualification"
                        placeholder="请选择"
                        data-stat-ignore
                        clearable
                    >
                        <veui-option
                            v-for="(item, index) in qualificationOption"
                            :key="index"
                            :label="item"
                            :value="item"
                        >
                        </veui-option>
                    </veui-select>
                    <div v-else>{{ formData.qualification || '无' }}</div>
                </veui-field>
                <veui-field
                    name="degree_license"
                    label="学位证书"
                    :class="{'text': !formData.degree_license || !formData.degree_license.length}"
                    :style="{'margin-bottom': isModify ? '32px' : '18px'}"
                >
                    <veui-uploader
                        v-if="isModify"
                        :class="{'ispass': !isModify}"
                        :accept="imageAccept"
                        max-size="5120kb"
                        :max-count="6"
                        :convert-response="(data) => convertResponse(data, 'degree_license')"
                        type="image"
                        :action="`${url}&bucketName=law_smart&storeDir=degree_license&ajax=true`"
                        ui="s"
                        :value="formData.degree_license"
                        @change="res => uploaderChange(res, 'degree_license')"
                    >
                    </veui-uploader>
                    <div
                        v-if="!isModify && formData.degree_license && formData.degree_license.length > 0"
                        class="licence-wrapper"
                    >
                        <div v-for="(item, index) in formData.degree_license" :key="index">
                            <div class="img-wrapper mult">
                                <img class="viewimg" :src="item.src">
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="(!formData.degree_license || formData.degree_license.length === 0) && !isModify"
                        class="not-upload"
                    >
                        未上传
                    </div>
                    <span v-if="isModify" class="decs">
                        <span>1.要求照片清晰可见<br/></span>
                        <span>2.照片5M以下，支持jpg/jpeg/png格式<br/></span>
                        <span>3.请上传与您学位对应的学位证书（扣章）<br/></span>
                    </span>
                </veui-field>
                <veui-field
                    name="honorary_title"
                    label="荣誉头衔"
                    class="honorary-title text"
                    :style="{'margin-bottom': isModify ? '30px' : '24px'}"
                >
                    <veui-input
                        v-if="isModify" v-model="formData.honorary_title"
                        placeholder="请输入您的荣誉头衔，使用“，”分隔"
                    />
                    <div v-if="isModify" class="decs">
                        请确保填写的每个荣誉头衔均有对应荣誉证书照片，该照片仅用于审核
                    </div>
                    <div v-else>
                        {{ formData.honorary_title || '无' }}
                    </div>
                </veui-field>
                <veui-field
                    class="honorary"
                    name="honorary_licence"
                    label="荣誉证书"
                    :class="{'text': !formData.honorary_licence || !formData.honorary_licence.length}"
                    :style="{'margin-bottom': isModify ? '18px' : '12px'}"
                >
                    <veui-uploader
                        v-if="isModify"
                        :class="{'ispass': !isModify}"
                        :accept="imageAccept"
                        :max-count="20"
                        max-size="5120kb"
                        :convert-response="(data) => convertResponse(data, 'honorary_licence')"
                        type="image"
                        :action="`${url}&bucketName=law_smart&storeDir=honorary_licence&ajax=true`"
                        ui="s"
                        :value="formData.honorary_licence"
                        @change="res => uploaderChange(res, 'honorary_licence')"
                    >
                    </veui-uploader>
                    <div
                        v-if="!isModify && formData.honorary_licence && formData.honorary_licence.length > 0"
                        class="licence-wrapper"
                    >
                        <div v-for="(item, index) in formData.honorary_licence" :key="index">
                            <div class="img-wrapper mult">
                                <img
                                    class="viewimg" :src="item.src"
                                    alt=""
                                >
                            </div>
                        </div>
                    </div>
                    <div v-if="(!formData.honorary_licence || !formData.honorary_licence.length) && !isModify">
                        无
                    </div>
                    <div v-if="isModify" class="decs">
                        <p>1.上传荣誉相关的证书和奖状照片，要求照片清晰可见</p>
                        <p>2.照片5M以下，支持jpg/jpeg/png格式</p>
                        <p>3.荣誉证书图片不会展示在律师主页</p>
                    </div>
                </veui-field>
                <veui-field
                    class="gender text"
                    name="gender"
                    label="性别"
                    :class="[isModify ? 'mb12' : 'mb10']"
                >
                    <div v-if="isModify" class="my-radios">
                        <div
                            v-for="item in genderList"
                            :key="item.value"
                            :value="item.value"
                            class="radio"
                            :class="{'selected': item.value === formData.gender}"
                            @click="selectGender(item.value)"
                        >
                            <div class="icon"></div>
                            <div class="name">{{ item.name }}</div>
                        </div>
                    </div>
                    <div v-else>
                        {{ formData.gender === 0 ? '男' : formData.gender === 1 ? '女' : '未填写' }}
                    </div>
                </veui-field>
            </veui-form>
        </div>
        <div
            v-if="isShowModifyBtn && !isModify"
            class="submit-field"
        >
            <veui-button
                class="modify-btn"
                ui="primary"
                @click="handleEdit"
            >修改信息</veui-button>
        </div>
        <div v-if="isModify" class="submit-field">
            <veui-button ui="primary" @click="postData('submit')">
                提交
            </veui-button>
            <veui-button
                v-if="$route.name === 'FillData'" ui="strong"
                class="ml15" @click="postData('normal')"
            >保存</veui-button>
            <veui-button
                v-if="isShowModifyBtn && isModify"
                class="ml15"
                ui="strong"
                @click="cancelModify"
            >取消</veui-button>
            <!-- 未认证律师初次认证，入驻协议和智能体协议合二为一 -->
            <div
                v-if="formData.first_approve === 0"
                class="form-agree"
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null"></veui-checkbox>
                <div class="form-agree-line">
                    <div>
                        <span>我已阅读并知晓</span>
                        <span class="form-href-terms" @click.stop="gotoAgreement('serve')">
                            《法行宝用户协议》
                        </span>
                        <!-- 【智能体强引导入口下线一期】PRD1：新认证不再自动创建智能体，
                             去除"自动创建并开启律师智能体"承诺文案与智能体说明 popover
                        <span>，并同意入驻后自动创建并开启律师智能体用于承接用户咨询</span>
                        <img
                            class="icon"
                            src="https://lvlin-base.bj.bcebos.com/fe-saas/page/law-info/tip-icon-black-1.png"
                            alt=""
                        />
                        <veui-popover
                            target="tip" position="top-start"
                            overlay-class="agent-protocol-popover"
                        >
                            <div class="popover-title">
                                一、什么是律师智能体：
                            </div>
                            <div class="popover-content">
                                律师智能体是您的在线AI分身，利用文心大模型能力和您个人专业知识内容，它能在您忙碌时即时回答用户常见问题，给出专业法律见解与建议，能够智能评估问题价值，并引导用户主动提供线索。
                            </div>
                            <div class="popover-title">
                                二、律师智能体设置：
                            </div>
                            <div class="popover-content">
                                <p>开启后，您的智能体将在用户相关场景中展示并参与回复。</p>
                                <p>您可随时通过左侧菜单「律师智能体-角色设置」进行上线或下线操作。</p>
                            </div>
                            <div class="popover-title">
                                三、哪里能看到我的智能体？
                            </div>
                            <div class="popover-content">
                                <div class="popover-content-image">
                                    <img src="https://lvlin-fe-saas.cdn.bcebos.com/material/agent-protocol/agent-2.png">
                                    <img src="https://lvlin-fe-saas.cdn.bcebos.com/material/agent-protocol/agent-1.png">
                                </div>
                            </div>
                        </veui-popover>
                        -->
                    </div>
                </div>
            </div>
            <!-- 二次修改认证信息，只展示入驻协议 -->
            <div v-else class="form-agree no-agent">
                <!-- 【智能体强引导入口下线一期】PRD2：注释「默认勾选创建智能体」区块
                     注意 is_create 语义反转：1=未创建，0=已创建
                <div v-if="agentInfo.is_create === 1" class="agent-protocol">
                    <veui-checkbox v-model="formData.auto_create_agent" :false-value="null">
                        开启律师智能体实现7x24h不间断咨询承接、无效线索过滤，高效线索转化，提交即同意
                    </veui-checkbox>
                    <agentProtocol></agentProtocol>
                </div>
                -->
                <div>
                    <veui-checkbox v-model="formData.isAgree" :false-value="null">我已阅读并知晓</veui-checkbox>
                    <span class="form-href-terms" @click.stop="gotoAgreement('serve')">
                        《法行宝用户协议》
                    </span>
                </div>
            </div>
        </div>
        <div class="exit">
            <div class="text" @click="cancelLawyerInfo">注销法行宝律师资质：点击申请</div>
        </div>
        <veui-dialog
            class="dialog"
            ui="narrow"
            :overlay-class="['confirm-submit-dialog']"
            :open.sync="submitDialgOpen"
            @ok="save"
            @cancel="submitDialgOpen = false"
        >
            <template #title>
                <span :style="{fontFamily: 'PingFang SC', fontSize: '20px'}">您确认提交资质么?</span>
            </template>
            <template #foot="{close}">
                <veui-button
                    ui="l primary"
                    class="dialog-button"
                    @click="close('ok')"
                >
                    确定
                </veui-button>
            </template>
            <span :style="{paddingTop: '10px', display: 'inline-block', fontSize: '16px'}">
                提交后，您的资质进入审核环节，审核结果会在1-2个工作日内通过消息中心同步您，请您自行登录平台查看审核结果，感谢
            </span>
        </veui-dialog>
        <!-- 提交成功弹窗 -->
        <service-guide-card
            v-if="submitSuceessOpen && !userInfo?.lawyer_info?.bind_wechat_status"
            title="提交成功！订阅微信服务号，实时获取审核结果"
            desc="实时获取审核结果"
            :bound="userInfo.lawyer_info.bind_wechat_status"
            @close="closeSubmitScueessDiolog"
        ></service-guide-card>
        <veui-dialog
            v-else
            class="dialog"
            ui="narrow"
            :overlay-class="['confirm-submit-dialog']"
            :open.sync="submitSuceessOpen"
            @ok="closeSubmitScueessDiolog('ok')"
            @cancel="closeSubmitScueessDiolog('cancle')"
        >
            <template #title>
                <span :style="{fontFamily: 'PingFang SC', fontSize: '20px'}">提交成功</span>
            </template>
            <template #foot="{close}">
                <veui-button
                    ui="l primary"
                    class="dialog-button"
                    @click="close('ok')"
                >
                    确定
                </veui-button>
            </template>
            <span :style="{paddingTop: '10px', display: 'inline-block', fontSize: '16px'}">审核结果将于1-3个工作日告知您，请耐心等待</span>
        </veui-dialog>
        <!-- 免费会员领取弹窗 -->
        <veui-dialog
            class="dialog"
            ui="narrow"
            :overlay-class="['claim-free-dialog']"
            :open.sync="freeVipClaimOpen"
            @cancel="closeFreeVipClaimOpen"
        >
            <template #title>
                <span :style="{fontFamily: 'PingFang SC', fontSize: '20px'}">提交成功</span>
            </template>
            <template #foot>
                <veui-button
                    ui="l primary"
                    class="dialog-button"
                    @click="saveFreeVipReceive"
                >
                    确定
                </veui-button>
            </template>
            <span :style="{paddingTop: '10px', display: 'inline-block', fontSize: '16px'}">审核结果将于1-3个工作日告知您，请耐心等待</span>
            <span :style="{paddingTop: '20px', display: 'inline-block'}" @click="changeReceive">
                <div v-if="isReceiveFree" class="icon-checked"></div><div v-else class="icon-not-checked"></div>
                认证通过后自动领取免费体验会员
                <div
                    class="quetion-icon"
                    @mouseenter="freeVipShowPopover"
                />
                <veui-popover
                    target="quetion-icons"
                    position="bottom"
                >
                    个人信息认证通过可获得免费体验会员领取资格，勾选此项认证通过自动为您升级为免费体验会员
                </veui-popover>
            </span>
            <span
                class="see-free-equity"
                @click="changeIntrace"
            >
                了解免费会员权益<veui-icon class="see-icon" name="chevron-right"/>
            </span>
        </veui-dialog>
        <!-- 免费会员权益弹窗 -->
        <veui-dialog
            class="dialog"
            ui="narrow"
            :overlay-class="['claim-free-explain-dialog']"
            :open.sync="freeVipExplain"
            @cancel="freeVipExplain = false"
        >
            <template #title>
                <span class="explain-dialog-title">免费体验会员权益说明</span>
            </template>
            <div class="explain-body" @scroll="handleExplainScroll">
                <img src="https://lvlin-base.cdn.bcebos.com/fe-saas/page/material/explain-content.png" class="explain-body-img">
                <div v-if="explainScrollTop" class="explain-bottom"></div>
                <div v-else class="explain-top"></div>
            </div>
        </veui-dialog>
        <veui-dialog
            :open.sync="showYearsChangeTip"
            @ok="showYearsChangeTip = false"
        >
            <template #title>
                提示
            </template>
            【执业年限】与【律师职务】信息请至少展示一个，否则将会影响您在搜索结果及小程序中的信息展现，请谨慎选择。
            <template #foot="{close}">
                <veui-button
                    ui="m primary"
                    @click="close('ok')"
                >
                    我知道了
                </veui-button>
            </template>
        </veui-dialog>
        <!-- 订阅push信息提示 -->
        <service-guide-card
            v-if="showPushTipSuccess && !userInfo?.lawyer_info?.bind_wechat_status"
            title="订阅审核结果通知"
            :baidu-bound="isSubPushTip"
            :wechat-bound="userInfo.lawyer_info.bind_wechat_status"
            subscription
            @close="showPushTipSuccess = false"
        ></service-guide-card>
        <veui-dialog
            v-else
            class="dialog"
            ui="narrow"
            :overlay-class="['confirm-submit-dialog']"
            :open.sync="showPushTipSuccess"
            @ok="showPushTipSuccess = false"
        >
            <template #title>
                <span :style="{fontFamily: 'PingFang SC', fontSize: '20px'}">订阅成功</span>
            </template>
            <template #foot="{close}">
                <veui-button
                    ui="l primary"
                    class="dialog-button"
                    @click="close('ok')"
                >
                    确定
                </veui-button>
            </template>
            <span :style="{paddingTop: '10px', display: 'inline-block', fontSize: '16px'}">
                您已成功订阅通知提醒，审核结果将通过百度APP告知您。建议开启手机通知权限，及时接收提醒。
            </span>
        </veui-dialog>
        <!-- 取消订阅push信息提示 -->
        <veui-dialog
            class="dialog"
            ui="narrow"
            :overlay-class="['confirm-submit-dialog']"
            :open.sync="showCanclePushTip"
            @ok="showCanclePushTip = false"
        >
            <template #title>
                <span :style="{fontFamily: 'PingFang SC', fontSize: '20px'}">温馨提示</span>
            </template>
            <template #foot="{close}">
                <veui-button
                    ui="l strong"
                    class="dialog-button-double dialog-button-double-first"
                    @click="handleSubPushTip(0)"
                >
                    仍要取消
                </veui-button>
                <veui-button
                    ui="l primary"
                    class="dialog-button-double"
                    @click="close('ok')"
                >
                    暂不取消
                </veui-button>
            </template>
            <span :style="{paddingTop: '10px', display: 'inline-block', fontSize: '16px'}">
                取消订阅则无法及时接收百度APP审核结果通知提醒，请谨慎取消。
            </span>
        </veui-dialog>
        <!-- 认证失败弹框 -->
        <confirmDialog
            v-if="isShowFailDialog && dialogContent.length"
            title="认证提交失败"
            confirm-btn="我知道了"
            :is-show-cancel-btn="false"
            :is-default-content="false"
            :is-show-close-icon="true"
            @confirm="isShowFailDialog = false"
            @cancel="isShowFailDialog = false"
        >
            <div v-for="item, index in dialogContent" :key="index">{{ item }}</div>
        </confirmDialog>
        <agreeDialog
            ref="agreeDialog"
            :first-approve="formData.first_approve"
            @confirmIsAgree="handleAgreeConfirm"
        ></agreeDialog>
        <cancelAuthDialog
            ref="cancelAuthDialog"
            @confirmCloseAccountPage="confirmCloseAccountPage"
        ></cancelAuthDialog>
        <veui-dialog
            :open.sync="isShowCancelQualification"
            ui="auto"
            :overlay-class="['cancel-qualification-dialog']"
            @ok="isShowCancelQualification = false"
        >
            <template #title>
                提示
            </template>
            <span :style="{paddingTop: '10px', display: 'inline-block', fontSize: '16px', width: '372px'}">
                您当前是法行宝会员，如需注销法行宝律师资质，请先联系您的代理商办理会员费退还事宜。
            </span>
            <template #foot="{close}">
                <div class="cancel-btn" @click="close('ok')">
                    <div class="text">确认</div>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
     * @file law-info.vue
     * @author baoleilei
     * @desc 执业信息认证
*/
import {
    Button,
    Form,
    Field,
    Input,
    Uploader,
    Select,
    Textarea,
    Checkbox,
    Fieldset,
    OptionGroup,
    Option,
    Alert,
    Icon,
    Dialog,
    NumberInput,
    RadioGroup,
    Popover
} from 'veui';
import 'veui-theme-dls-icons/check-circle';
import 'veui-theme-dls-icons/info-circle-solid';
import {cloneDeep, isBoolean} from 'lodash';
import mixinajax from '@/mixins/ajax';
import cropperAvator from './cropper-avator-ai.vue';
import confirmDialog from '../../../components/confirm-dialog.vue';
import {mapActions, mapState} from 'vuex';
import ServiceGuideCard from '@/components/service-guide-card.vue';
import agreeDialog from '../components/agree-dialog.vue';
// 【智能体强引导入口下线一期】PRD2：组件文件保留，仅注释 import 与注册，恢复时同步恢复
// import agentProtocol from '../components/agent-protocol.vue';
import authenticationGuideCard from '@/components/authentication-guide-card.vue';
import cancelAuthDialog from '../components/cancel-auth-dialog.vue';

const url = {
    domain: '/bp/api/lawyer/get_lawyer_domain',
    cityNext: '/bp/api/city/cityAll',
    setPushStatus: '/bp/api/user/saveshoubaisubscribe'
};

export default {
    name: 'matrial',
    mixins: [mixinajax],
    components: {
        'veui-button': Button,
        'veui-field': Field,
        'veui-form': Form,
        'veui-input': Input,
        'veui-select': Select,
        'veui-uploader': Uploader,
        'veui-textarea': Textarea,
        'veui-checkbox': Checkbox,
        'veui-fieldset': Fieldset,
        'veui-option-group': OptionGroup,
        'veui-option': Option,
        'veui-alert': Alert,
        'veui-dialog': Dialog,
        'veui-icon': Icon,
        'veui-number-input': NumberInput,
        'cropper-avator-ai': cropperAvator,
        'veui-radio-group': RadioGroup,
        'veui-popover': Popover,
        confirmDialog,
        'service-guide-card': ServiceGuideCard,
        agreeDialog,
        // 【智能体强引导入口下线一期】PRD2：模板引用已注释，注册一并注释以通过 vue/no-unused-components
        // agentProtocol,
        authenticationGuideCard,
        cancelAuthDialog
    },
    props: {
        isEdit: {
            'type': Boolean,
            'default': false
        },
        editAnchor: {
            'type': String,
            'default': ''
        },
        showDomainError: {
            'type': Boolean,
            'default': false
        }
    },
    watch: {
        userInfo: {
            handler(val) {
                this.formatData();
            },
            immediate: true
        }
    },
    data() {
        let self = this;
        return {
            validators: [
                {
                    fields: ['mobile_number'],
                    validate(mobile_number) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                let isPhone = (/^1[3456789]\d{9}$/.test(mobile_number))
                                    || (/^[1][3-9]{2}(\*\*\*\*)[0-9]{4}$/.test(mobile_number));
                                if (!isPhone) {
                                    res = {
                                        mobile_number: '请输入正确的手机号'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                },
                {
                    fields: ['register_id'],
                    validate(register_id) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (+register_id < 0) {
                                    res = {
                                        register_id: '不能为负数'
                                    };
                                }
                                else if (register_id && register_id.length !== 17) {
                                    res = {
                                        register_id: '请输入17位执业证书号'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                },
                {
                    fields: ['register_domain'],
                    validate(register_domain) {
                        // let that = this;
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                let lawyerFieldsNum = self.formData.max_fields_num || 2;
                                if (register_domain && (register_domain.length > lawyerFieldsNum)) {
                                    res = {
                                        register_domain: `您最多只能筛选${lawyerFieldsNum}个领域标签`
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                }
            ],
            presonalValidators: [
                {
                    fields: ['personal_intro'],
                    validate(personal_intro) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (personal_intro && (personal_intro.length < 20 || personal_intro.length > 500)) {
                                    res = {
                                        personal_intro: '请输入20-500个字符'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                }
            ],
            formData: {
                isAgree: null,
                lawyer_position: null, // 律师职务
                lawyer_position_image: '', // 律师职务证明
                show_register_years: 1, // 是否展示执业年限
                show_lawyer_position: 1, // 是否展示律师职务
                id_code: '',
                name: '',
                register_id: null,
                mobile_number: null,
                register_years: null,
                register_law_firm: '',
                register_region: [],
                identity_head_image: '',
                identity_national_image: '',
                register_image: [],
                personal_avatar: '',
                personal_intro: '',
                personal_assist_licence: null, // 简介辅助证明
                info_status: '0',
                office_address: '', // 办公地址
                graduated_school: '', // 毕业院校
                degree_license: [], // 学位证
                graduated_license: null, // 毕业证书
                honorary_title: '', // 荣誉头衔
                honorary_licence: null, // 荣誉证书
                register_domain: null, // 擅长领域
                register_philosophy: '', // 执业理念
                issuing_authority: '', // 发证机构
                gender: '', // 性别
                first_approve: null, // 0: 新认证，firstApprove: 修改信息
                // 【智能体强引导入口下线一期】PRD1/PRD2：默认值由 true 改为 false，不再默认勾选创建智能体
                // 原：auto_create_agent: true, // 1: 自动创建智能体，0: 不自动创建
                auto_create_agent: false, // 1: 自动创建智能体，0: 不自动创建
                qualification: null, // 学历
                register_image_home: null, // 执业证书首页
                register_image_record: null, // 执业证书副页
                register_image_other: []
            },
            lawyerFieldsNum: 2, // 可以绑定的数量
            regionOption: [], // 省市区
            doaminOption: [], // 擅长领域
            url: '/bp/api/upload?ajax=1&bdstoken=',
            isModify: true, // 是否在修改中
            submitDialgOpen: false,
            info_status: '0', // 代表资料状态 0 = 编辑中 2 = 审核中 4 = 执业审核成功 6 = 执业审核失败
            postParma: null,
            opType: '',
            maxModifyCount: 10,
            imageAccept: '.jpg,.png,.jpeg,.gif,.wbmp,.xbm',
            licenses: [
                {
                    label: '是',
                    value: 1
                },
                {
                    label: '否',
                    value: 0
                }
            ],
            positionOption: ['专职律师', '主任律师', '合伙人律师', '高级合伙人律师'],
            showYearsChangeTip: false,
            isShowFailDialog: false,
            dialogContent: [],
            // 提交成功弹窗展示
            submitSuceessOpen: false,
            // 免费会员认领弹窗展示
            freeVipClaimOpen: false,
            // 免费会员介绍弹窗展示
            freeVipExplain: false,
            // 是否同意认领
            isReceiveFree: true,
            // 免费会员介绍是否滚动到顶部
            explainScrollTop: true,
            // 免费会员领取是否请求中，请求锁
            isSaveFreeVipReceive: false,
            // 是否订阅push消息提示
            isSubPushTip: false,
            // 展示订阅成功弹窗
            showPushTipSuccess: false,
            // 展示取消订阅挽留弹窗
            showCanclePushTip: false,
            genderList: [{
                name: '男',
                value: 0
            }, {
                name: '女',
                value: 1
            }],
            isShowCreateAgentDialog: false,
            avatarList: [{
                pic: 'https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-11.png',
                text: '生活照'
            }, {
                pic: 'https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-1.png',
                text: '五官遮挡'
            }, {
                pic: 'https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-22.png',
                text: '模糊不清'
            }, {
                pic: 'https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-3.png',
                text: '光线不足'
            }, {
                pic: 'https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-4.png',
                text: '面部过大'
            }],
            qualificationOption: ['本科', '硕士', '博士'],
            uploadLicence: true,
            // 未退费的会员 - 注销资质弹窗
            isShowCancelQualification: false,
            showRegisterError: false,
            showRegisterRecordError: false,
            hasError: false, // 边框、文案标红
            originAvatar: ''
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.lawStore.userInfoNew || {},
            vipInfo: state => state.lawStore.vipInfo,
            useruk: state => state.lawStore.userInfoNew.uk || '',
            agentInfo: state => state.lawStore.agentInfo || {}
        }),
        missingDomainCount() {
            const max = this.lawyerFieldsNum || this.formData.max_fields_num || 2;
            const selected = Array.isArray(this.formData.register_domain) ? this.formData.register_domain.length : 0;
            return Math.max(0, max - selected);
        },
        statusType: function () {
            const {info_status} = this.userInfo?.lawyer_info || {};
            if (+info_status === 2) {
                return {
                    value: 'warning',
                    label: '认证信息审核中请您耐心等待，工作人员会在1-3个工作日反馈审核结果。'
                };
            }
            else if (+info_status === 4) {
                return {
                    value: 'success',
                    label: '执业信息审核成功'
                };
            }
            else if (+info_status === 6) {
                return {
                    value: 'error',
                    label: '认证信息审核失败' + (this.formData.audit_reason ? `：${this.formData.audit_reason}` : '')
                };
            }
            return '';
        },
        isShowModifyBtn: function () {
            const {info_status} = this.userInfo?.lawyer_info || {};
            return +info_status !== 0 && +info_status !== 2;
        },
        isShowAiAvatarsBtn() {
            return !!this.formData.personal_avatar;
        }
    },
    created() {
        this.getData();
    },
    methods: {
        ...mapActions({
            submitInfo: 'lawStore/submitInfo',
            getAgentData: 'lawStore/getAgentData',
            getUserInfoNew: 'lawStore/getUserInfoNew'
        }),

        /**
         * 关闭提交成功弹窗，并打点
         * type string
         */

        handleSubPushTip(status) {
            this.$http.post(url.setPushStatus, {
                shoubai_subscribe: status
            }).then(res => {
                if (res && +res.code === 0) {
                    this.isSubPushTip = !!status;
                    if (status === 1) {
                        this.showPushTipSuccess = true;
                    }
                    else {
                        this.showCanclePushTip = false;
                        this.$toast.success('您已取消订阅审核结果通知');
                    }
                    return;
                }
                this.$toast.error('操作失败，请稍后再试');
            }).catch(err => {
                this.$toast.error('操作失败，请稍后再试');
            });
        },

        /**
         * 关闭提交成功弹窗，并打点
         * type string
         */

        closeSubmitScueessDiolog(type) {
            this.submitSuceessOpen = false;
            this.$wywLog.send({
                serverId: 17552,
                area: type === 'ok' ? 'tjcgtc-qr-btn' : 'tjcgtc-close-btn',
                action: 'click'
            });
        },

        /**
         * 关闭免费会员领取弹窗，并打点
         */

        closeFreeVipClaimOpen() {
            this.freeVipClaimOpen = false;
            this.$wywLog.send({
                serverId: 17552,
                area: 'zdlqtc-close-btn',
                action: 'click'
            });
        },

        /**
         * 展示免费会员规则打点
         */

        freeVipShowPopover() {
            this.$wywLog.send({
                serverId: 17552,
                area: 'zdlqtc-wh-btn',
                action: 'hover'
            });
        },

        /**
         * 修改是否领取免费会员
         */

        changeReceive() {
            this.isReceiveFree = !this.isReceiveFree;
        },

        /**
         * 展示免费会员介绍弹窗，并打点
         */

        changeIntrace() {
            this.$wywLog.send({
                serverId: 17552,
                area: 'zdlqtc-ljqy-btn',
                action: 'click'
            });
            this.$wywLog.send({
                serverId: 17552,
                area: 'zdlqtc-qysm',
                action: 'show'
            });
            this.freeVipExplain = !this.freeVipExplain;
        },

        /**
         * 领取免费会员，并打点
         */

        saveFreeVipReceive() {
            if (this.isSaveFreeVipReceive) {
                return;
            }
            this.isSaveFreeVipReceive = true;
            this.$wywLog.send({
                serverId: 17552,
                area: 'zdlqtc-qr-btn',
                action: 'click',
                index: this.isReceiveFree ? 1 : 0
            });
            if (!this.isReceiveFree) {
                this.freeVipClaimOpen = false;
                this.isSaveFreeVipReceive = false;
                return;
            }
            this.$http.post('/bp/api/user/saveReceiveTrialVip', {
                auto_receive_trial_vip: 1,
                params: JSON.stringify({
                    auto_receive_trial_vip: 1
                })
            }).then(res => {
                if (res && res.data === 1) {
                    this.freeVipClaimOpen = false;
                    this.isSaveFreeVipReceive = false;
                    return;
                };
                this.$toast.error('免费会员开通失败，请稍后再试');
                this.isSaveFreeVipReceive = false;
            }).catch(err => {
                this.$toast.error('免费会员开通失败，请稍后再试');
                this.isSaveFreeVipReceive = false;
            });
        },

        /**
         * 免费会员介绍弹窗滚动事件
         */

        handleExplainScroll(e) {
            if (this.handleExplainScrollTimeout) {
                clearTimeout(this.handleExplainScrollTimeout);
                this.handleExplainScrollTimeout = null;
            }
            this.handleExplainScrollTimeout = setTimeout(() => {
                const {scrollHeight, scrollTop, clientHeight} = e.target;
                if (scrollTop === 0) {
                    this.explainScrollTop = true;
                }
                if (scrollHeight - scrollTop === clientHeight) {
                    this.explainScrollTop = false;
                }
                clearTimeout(this.handleExplainScrollTimeout);
                this.handleExplainScrollTimeout = null;
            }, 100);
        },
        handleGotoAuth() {
            this.$emit('handleGotoAuth', this.formData.pass_status + 1);
        },
        showYearsChange(e) {
            if (e === 0 && this.formData.first_approve === 1) {
                this.showYearsChangeTip = true;
            }
        },
        gotoAgreement(type) {
            if (type === 'serve') {
                window.open('https://lvlin-law.cdn.bcebos.com/assets/common/fxb-fw-xy.pdf');
            }
            else if (type === 'city') {
                window.open('https://lvlin-base.cdn.bcebos.com/fe-saas/common/city_level.pdf');
            }
            else if (type === 'virtual') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/virtual_number_rule.pdf');
            }
            else {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf');
            }
        },
        cancelModify() {
            this.$refs.form.clearValidities();
            this.$refs.personalForm?.clearValidities();
            this.isModify = false;
            this.hasError = false;
            this.$emit('inEdit');
            this.$emit('getData');
        },
        getData() {
            this.getDomain();
            this.getCity();
        },
        // 格式化后端返回数据
        setImgValueValueByStrValue(key, value) {
            this.formData[key] = value ? value.split('$').map((item, index) => {
                return {
                    src: item,
                    key: key + index
                };
            }) : [];
        },
        uploadSuc(url) {
            this.formData.personal_avatar = url || '';
        },
        formatData() {
            const {lawyer_info, pass_info, first_approve} = this.userInfo || {};
            this.formData = Object.assign(this.formData, {...lawyer_info, ...pass_info, isAgree: null, first_approve});
            if (lawyer_info) {
                this.originAvatar = this.formData.personal_avatar;
                this.lawyerFieldsNum = this.formData.max_fields_num || 2;
                this.info_status = String(this.formData.info_status);
                if (this.formData.mobile_number) {
                    this.formData.mobile_number = +(this.formData.mobile_number);
                }
                this.isSubPushTip = lawyer_info && lawyer_info.shoubai_subscribe === 1;
                // url参数带有isEdit则表示进入编辑状态
                this.isModify = this.info_status === '0' || this.isEdit;
                this.formData.register_id += '';
                this.formData.show_register_years = +this.formData.show_register_years === 0 ? 0 : 1;
                this.formData.show_lawyer_position = +this.formData.show_lawyer_position === 0 ? 0 : 1;
                this.formData.register_region = this.formData.register_region
                    ? this.formData.register_region.split('$')?.map(i => +(i)) : [];
                let register_domain = this.formData.register_domain;
                if (register_domain) {
                    register_domain = register_domain.replace(/交通保险/g, '保险理赔');
                }
                this.formData.register_domain = register_domain
                    ? register_domain.split('$') : [];
                this.setImgValueValueByStrValue('honorary_licence', this.formData.honorary_licence);
                this.setImgValueValueByStrValue('graduated_license', this.formData.graduated_license);
                this.setImgValueValueByStrValue('degree_license', this.formData.degree_license);
                if (this.formData.register_image) {
                    const registerImageList = this.formData.register_image.split('$') || [];
                    this.formData.register_image = registerImageList;
                    // this.setImgValueValueByStrValue('register_image', this.formData.register_image);
                    if (registerImageList[0]) {
                        this.formData.register_image_home = registerImageList[0];
                    }
                    if (registerImageList[1]) {
                        this.formData.register_image_record = registerImageList[1];
                    }
                    if (registerImageList?.length > 2) {
                        this.setImgValueValueByStrValue('register_image_other', registerImageList.slice(2)?.join('$'));
                    }
                }
                this.setImgValueValueByStrValue('personal_assist_licence', this.formData.personal_assist_licence);
                // 避免初始化 通过watch重置register_years
                setTimeout(() => {
                    if (this.formData.register_years) {
                        this.formData.register_years = +(this.formData.register_years);
                    }
                    // url参数带有isEdit则锚点到指定锚点上
                    if (this.isEdit) {
                        if (this.editAnchor) {
                            document.querySelector(`#${this.editAnchor}`)
                                .scrollIntoView({block: 'center', behavior: 'smooth'});
                        }
                        // 通知页面已强制进入编辑，可以取消props，防止之后再强制进入编辑
                        // this.$emit('inEdit');
                    }
                });
            }
        },
        // 切换编辑状态
        handleEdit() {
            if (this.formData.pass_status < 2) {
                this.$emit('handleGotoAuth', this.formData.pass_status + 1);
                return;
            }
            this.isModify = !this.isModify;
            document.querySelector('#practice-info').scrollIntoView(true);
            this.formatStorageData();
            this.$wywLog.send({
                serverId: 16233,
                area: 'edit_btn',
                action: 'click'
            });
            if (this.isModify && !this.formData.register_domain) {
                this.$nextTick(() => {
                    if (this.$refs.veuiselect) {
                        this.$refs.veuiselect.realValue = [];
                    }
                });
            }
        },
        formatStorageData() {
            let claimData = this.useruk ? localStorage.getItem(this.useruk) : '';
            if (!claimData) {
                return;
            }
            claimData = JSON.parse(claimData);
            this.formData = {
                ...this.formData,
                ...(claimData.register_id && {registerId: claimData.register_id} || {}),
                ...(claimData.lawyer_position && {lawyer_position: claimData.lawyer_position} || {}),
                ...(claimData.gender && {gender: claimData.gender === '男' ? 0 : claimData.gender === '女' ? 1 : 2}
                    || {}),
                ...(claimData.register_firm && {register_law_firm: claimData.register_firm} || {}),
                ...(claimData.issuing_authority && {issuing_authority: claimData.issuing_authority} || {}),
                ...(claimData.identity_head_image && {identity_head_image: claimData.identity_head_image} || {}),
                ...(claimData.identity_national_image
                    && {identity_national_image: claimData.identity_national_image} || {})
            };
        },
        uploaderChange(res, key) {
            if (Array.isArray(res)) {
                this.formData[key] = res;
                return;
            }
            if (key === 'register_image_home' && res?.src && this.showRegisterError) {
                this.showRegisterError = false;
            }
            if (key === 'register_image_record' && res?.src && this.showRegisterRecordError) {
                this.showRegisterRecordError = false;
            }
            this.formData[key] = res ? res.src : '';
        },
        convertResponse(data, key) {
            const {bos_url, name} = data?.data || {};
            if ((key === 'register_image_home' || key === 'register_image_record' || key === 'identity_head_image'
                || key === 'identity_national_image') && bos_url) {
                this.smartStruct(bos_url, key);
            }
            return ({
                success: data && (Number(data.code) === 0),
                src: bos_url,
                message: data && data.msg,
                key: name
            });
        },
        /**
         * 用户点击确认协议弹窗按钮后的处理函数
         */
        handleAgreeConfirm() {
            this.formData.isAgree = true;
            // 用户确认协议后，打开确认提交弹窗
            this.submitDialgOpen = true;
            this.stashPostparma('submit');
        },
        postData(op_type) {
            if (op_type === 'submit') {
                let arr = [
                    this.$refs.form.validate()
                ];
                if (this.$refs.personalForm) {
                    arr.push(this.$refs.personalForm.validate());
                }
                Promise.all(arr).then(res => {
                    const [flag1, flag2] = res || {};
                    const {show_register_years, lawyer_position} = this.formData;
                    const {register_image_home, register_image_record} = this.formData;
                    this.showRegisterError = !register_image_home;
                    this.showRegisterRecordError = !register_image_record;
                    if (!register_image_home) {
                        this.$toast.info('执业证首页未上传，请上传后重新提交');
                        return;
                    }
                    if (!register_image_record) {
                        this.$toast.info('执业证备案页未上传，请上传后重新提交');
                        return;
                    }
                    if (isBoolean(flag1) && flag1 && (res.length === 1 || flag2 && isBoolean(flag2))) {
                        // 执业年限和律师职务必选一个展示
                        if (this.$refs.personalForm && !show_register_years && !lawyer_position) {
                            this.$toast.info('【执业年限】与【律师职务】信息请至少展示一个，否则将会影响您在搜索结果及小程序中的信息展现，请谨慎选择。');
                            return;
                        }
                        // 提交打点
                        this.$wywLog.send({
                            serverId: 16233,
                            area: 'tj_btn',
                            action: 'click',
                            isAi: this.$refs.cropperAvatorAi.isSubmitAi ? '1' : '0'
                        });
                        this.stashPostparma(op_type);
                        // 没有勾选协议需要先展示协议确认弹窗
                        if (!this.formData.isAgree) {
                            return this.$refs.agreeDialog.openDialog();
                        }
                        this.submitDialgOpen = true;
                    }
                    else {
                        let toast = {
                            content: '请完成必填选项',
                            duration: 1
                        };
                        this.$Message.info(toast);
                    }
                }).catch(e => {});
            }
            else {
                this.$refs.form.validate().then(flag => {
                    if (isBoolean(flag) && flag) {
                        this.stashPostparma(op_type);
                        this.save();
                    }
                    else {
                        let toast = {
                            content: '请完成必填选项',
                            duration: 1
                        };
                        this.$Message.info(toast);
                    }
                });
            }
        },
        // 暂存下保存数据
        stashPostparma(op_type) {
            let register_image = [
                this.formData.register_image_home,
                this.formData.register_image_record,
                ...(this.formData.register_image_other.map(item => item.src) || [])
            ];
            let data  = {
                ...this.formData,
                op_type,
                submit_source: this.$route.name === 'FillData' ? 'register' : 'edit',
                graduated_license: this.formData.graduated_license
                    && this.formData.graduated_license.map(item => item.src).join('$'),
                personal_assist_licence: this.formData.personal_assist_licence
                    && this.formData.personal_assist_licence.map(item => item.src).join('$'),
                register_domain: this.formData.register_domain && this.formData.register_domain.join('$'),
                register_region: this.formData.register_region && this.formData.register_region.join('$'),
                honorary_licence: this.formData.honorary_licence
                    && this.formData.honorary_licence.map(item => item.src).join('$'),
                // 【智能体强引导入口下线一期】PRD1/PRD2：认证提交不再自动创建智能体，固定传 0
                // 原：auto_create_agent: this.formData.auto_create_agent ? 1 : 0,
                auto_create_agent: 0,
                degree_license: this.formData.degree_license
                    && this.formData.degree_license.map(item => item.src)?.join('$') || null,
                register_image: register_image?.join('$') || '' // 执业证照片
            };
            delete data.city;
            this.postparma = cloneDeep(data);
            this.opType = op_type;
        },
        firstSave() {
            let register_image = [
                this.formData.register_image_home,
                this.formData.register_image_record,
                ...(this.formData.register_image_other.map(item => item.src) || [])
            ];
            return new Promise((resolve, reject) => {
                this.$http.post('/bp/api/user/save', {
                    register_id: this.formData.register_id, // 执业证照片识别出的执业证号
                    register_stage: 2, // 阶段 1: 待完善 2: 已完善
                    personal_avatar: this.formData.personal_avatar, // 职业形象照
                    register_image: register_image?.join('$') || '', // 执业证照片
                    identity_head_image: this.formData.identity_head_image, // 身份证正面-人像面
                    identity_national_image: this.formData.identity_national_image, // 身份证背面-国徽面
                    register_years: this.formData.register_years, // 执业年限
                    register_law_firm: this.formData.register_law_firm, // 律所名称
                    show_register_years: this.formData.show_register_years, // 是否展示执业年限
                    mobile_number: this.formData.mobile_number, // 执业手机号
                    register_region: this.formData.register_region?.join('$'), // 执业地区
                    register_domain: this.formData.register_domain?.join('$'), // 执业领域
                    fr: this.$route.query.from || this.$route.query.fr || '',
                    // 【智能体强引导入口下线一期】PRD1：首次认证提交不再自动创建智能体，固定传 0
                    // 原：auto_create_agent: this.formData.auto_create_agent ? 1 : 0
                    auto_create_agent: 0
                }).then(res => {
                    if (+res.code !== 0) {
                        reject(res);
                        return;
                    }
                    this.getUserInfoNew();
                    resolve(res);
                }).catch(err => {
                    reject();
                });
            });
        },
        save() {
            let fn = this.submitInfo;
            if (this.formData.first_approve === 0) {
                fn = this.firstSave;
            }
            fn({
                ...this.postparma,
                mobile_number: '' + this.postparma.mobile_number,
                fr: this.$route.query.from || this.$route.query.fr || '',
                is_ai_avatar: this.$refs.cropperAvatorAi.isSubmitAi ? 1 : 0, // 是否AI头像
                original_avatar: this.$refs.cropperAvatorAi.originAvatar || this.originAvatar,
                ai_avatar1: this.$refs.cropperAvatorAi.$refs.avatarChooseDialog?.list?.[0] || '',
                ai_avatar2: this.$refs.cropperAvatorAi.$refs.avatarChooseDialog?.list?.[1] || ''
            }).then(res => {
                // 提交完成打点
                this.useruk && localStorage.setItem(this.useruk, '');
                this.$wywLog.send({
                    serverId: 16233,
                    area: 'tj-btn-pc',
                    action: 'click',
                    index: '01',
                    isAi: this.$refs.cropperAvatorAi.isSubmitAi ? '1' : '0',
                    autoCreateAgent: this.postparma.auto_create_agent ? 1 : 0
                });
                this.cancelModify();
                this.getAgentData();
                // 认证失败，职业资格证已经被认证了
                // if (+res.code === 8007) {
                //     this.dialogContent = res?.msg ? res.msg.split('</br>') : [];
                //     this.isShowFailDialog = true;
                // }
                this.$nextTick(() => {
                    document.documentElement.scrollTop = 0;
                    const {lawyer_info, user_role} = this.userInfo || {};
                    const create_time = (lawyer_info && lawyer_info.create_time || '').split(' ')[0];
                    let timeArr = create_time.split('-').join('') || '';
                    // 如果auto_receive_trial_vip是0，这代表可以领取免费会员，弹出弹窗
                    const {crm_enter_type} = lawyer_info || {};
                    if ((user_role === -1 && !lawyer_info)
                        || (crm_enter_type === 2 && this.vipInfo && !lawyer_info.business_lawyer_id
                            && lawyer_info.auto_receive_trial_vip === 0
                            && !this.vipInfo.validityStart && Number(timeArr) > 20221000)) {
                        this.freeVipClaimOpen = true;
                        this.$wywLog.send({
                            serverId: 17552,
                            area: 'zdlqtc',
                            action: 'show'
                        });
                    }
                    else {
                        // 否则提交成功，弹出弹窗
                        this.submitSuceessOpen = true;
                        this.$wywLog.send({
                            serverId: 17552,
                            area: 'tjcgtc',
                            action: 'show'
                        });
                    }
                });
            }).catch(res => {
                res && this.$wywLog.send({
                    serverId: 16233,
                    area: 'tj-btn-pc',
                    action: 'click',
                    index: '00'
                });
                this.$toast.error(res && res.msg || '修改失败，请稍候再试~');
            }).finally(() => {
                // 【智能体强引导入口下线一期】PRD2：勾选项已下线，恢复为不勾选
                // 原：this.formData.auto_create_agent = true;
                this.formData.auto_create_agent = false;
            });
        },
        getCity(city_code = 0) {
            this.$http.get(url.cityNext, {
                city_code
            }).then(res => {
                if (!res || +res.code !== 0) {
                    return;
                }
                let data = res.data;
                if (data) {
                    this.regionOption = data;
                }
            });
        },
        getDomain() {
            this.$http.get(url.domain, {
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (res) {
                    let data =  res;
                    this.doaminOption = data;
                }
            });
        },

        /**
         * 性别选择
         * @param {Number} value 选中值
         */

        selectGender(value) {
            if (value === this.formData.gender) {
                this.formData.gender = 2;
                return;
            }
            this.formData.gender = value;
        },

        // ocr图片识别，返回识别结果分三种类型处理
        smartStruct(url, type) {
            this.$http.post('/bp/api/smart_struct', {
                url,
                type: type.startsWith('register_image') ? 1 : 2 // 执业证1，身份证2
            }).then(res => {
                // 识别失败
                if (!res || +res.code !== 0) {
                    this.$toast.error((type === 1 ? '执业证' : '身份证') + '未识别到或识别不全，请重新上传清晰照片');
                    return;
                }
                if (type === 'register_image_home' || type === 'register_image_record') {
                    const group = res.data?.words_result?.struct_info.group || [];
                    let register_id = ''; // 执业证号
                    let register_years = ''; // 执业年限
                    let register_law_firm = ''; // 执业律所
                    group.forEach(item => {
                        if (item?.key?.[0]?.word === '执业证号') {
                            register_id = item?.value?.[0]?.word;
                        }
                        else if (item?.key?.[0]?.word === '执业机构') {
                            register_law_firm = item?.value?.[0]?.word;
                        }
                    });
                    if (register_id && register_id.length === 17) {
                        register_years = this.getPracticeYears(register_id);
                    }
                    if (register_id) {
                        this.formData.register_id = register_id;
                    }
                    if (register_years) {
                        this.formData.register_years = register_years;
                    }
                    if (register_law_firm) {
                        this.formData.register_law_firm = register_law_firm;
                    }
                }
                // 身份证正面
                if (type === 'identity_head_image') {
                    // 处理身份证信息
                    const group = res.data || {};
                    if (!group.id_card_no || group.id_card_no.length !== 18) {
                        this.$toast.error('身份证人像面未识别到或识别不全，请重新上传清晰照片。');
                        this.formData.identity_head_image = null;
                        return;
                    }
                }
                // 处理身份证国徽面信息
                if (type === 'identity_national_image') {
                    const group = res.data || {};
                    if (!group.issue_office) {
                        this.formData.identity_national_image = null;
                        this.$toast.error('身份证国徽面未识别到或识别不全，请重新上传清晰照片。');
                        return;
                    }
                };
            }).catch(err => {
                this.$toast.error('识别失败，请稍后再试');
            });
        },

        /**
         * 从17位律师执业证号中提取执业年限
         * @param {string} licenseNo - 律师执业证号(需完整17位)
         * @returns {Number} 执业年限描述(如"22")
         */

        getPracticeYears(licenseNo) {
            // 验证输入格式
            if (!licenseNo || licenseNo.length !== 17) {
                return;
            }
            // 提取执业起始年份(第6-9位)
            const startYear = Number(licenseNo.substring(5, 9));
            const currentYear = new Date().getFullYear();
            // 计算基础年限，以实际已满年数为准（如：两年半计为两年）
            let years = currentYear - startYear;
            return years;
        },
        clickEdit(editAnchor) {
            this.isModify = true;
            this.$nextTick(() => {
                document.querySelector(`#${editAnchor}`).scrollIntoView(true);
            });
            if (editAnchor === 'practice-info') {
                this.hasError = true;
            }
        },
        // 注销用户认证信息
        cancelLawyerInfo() {
            // 非会员 可以继续注销
            if (this.vipInfo.vipStatus === '0') {
                return this.$refs.cancelAuthDialog.openDialog();
            }
            this.isShowCancelQualification = true;
        },

        // 确认注销
        confirmCloseAccountPage() {
            this.$emit('changeCloseAccountPage', true);
        },
        showAvatarChooseModal() {
            this.$wywLog.send({
                serverId: 20062,
                area: 'dz-ai-avatar',
                action: 'click'
            });
            this.$refs?.cropperAvatorAi.openAvatarChooseModal();
        }
    }
};
</script>

<style lang="less" scoped>
/* stylelint-disable no-duplicate-selectors */
@input-width: 530px;  // 定义宽度变量

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
    appearance: none;
}

.authentice .licence-wrapper {
    width: 940px;
}

.authentice .download-app-banner {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 9px;
    margin-bottom: 27px;
}

.authentice .name-pass {
    color: #00d154;
    padding-left: 20px;

    &-not {
        color: #848691;
        padding-left: 13px;
    }
}

.authentice {
    ::v-deep .veui-label {
        min-width: 60px;
        color: #1e1f24;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
    }
    // 只读
    .isViewModel {
        ::v-deep .veui-label {
            color: #848691;
        }
    }

    .gender {
        margin-bottom: 0;
    }

    .is-edit {
        ::v-deep .veui-field-label {
            height: 48px;
        }

        ::v-deep .veui-field {
            &.honorary {
                .veui-uploader-media {
                    max-width: 620px;
                }
            }

            &.graduated-license {
                .veui-uploader-media {
                    max-width: 650px;
                }
            }
        }
    }

    ::v-deep .veui-field {
        &.show_register_years {
            .veui-field-label {
                width: auto;
            }
        }
    }

    .form {
        .form-tips {
            color: #848691;
        }

        .blue-tips {
            border: 1px solid #e0ebff;
            background: #0055ff0d;
            height: 50px;
            border-radius: 6px;
            color: #1e1f24;
            padding-left: 24px;
            display: flex;
            align-items: center;
            margin-bottom: 30px;

            .icon {
                height: 16px;
                width: 16px;
                margin-right: 8px;
                background: url("https://lvlin-fe-saas.bj.bcebos.com/material/Frame%201.png") no-repeat center center / 100% auto;
            }
        }

        .text-info {
            position: relative;
        }

        .register-years-field ::v-deep .veui-field-content {
            flex-wrap: wrap;
            width: 100%;
            align-items: center;
        }

        .register-years-field {
            .desc {
                width: 389px;
                color: #848691;
                font-size: 14px;
                margin-left: 12px;
            }
        }

        .register-domain {
            ::v-deep .veui-select-trigger {
                display: flex;
                align-items: center;

                .veui-input-before {
                    padding-bottom: 3px;
                }
            }

            .domain-select-wrap {
                display: flex;
                flex-direction: column;
            }

            .domain-error-tip {
                display: flex;
                align-items: center;
                margin-top: 8px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: rgba(229, 115, 0, 1);
                line-height: 20px;

                .tip-icon {
                    width: 16px;
                    height: 16px;
                    margin-right: 4px;
                    color: rgba(229, 115, 0, 1);
                }
            }
        }
    }

    ::v-deep .form-agree {
        display: flex;
        // align-items: center;
        margin-top: 18px;

        &.no-agent {
            display: block;
        }

        .agent-protocol {
            display: flex;
        }

        .veui-checkbox {
            margin-top: 3px;
        }

        .form-agree-line {
            margin-left: 10px;

            .form-agree-second-line {
                display: flex;
                align-items: center;
            }
        }
    }

    .user {
        position: relative;

        .modify-btn {
            position: absolute;
            top: 30px;
            right: 25px;
        }
    }

    .card {
        padding: 30px;
        background: #fff;
        border-radius: 8px;
        box-sizing: content-box;

        &#personal-info {
            padding-bottom: 14px;
        }

        ::v-deep .veui-field-label {
            justify-content: flex-end;
            width: 77px;
            margin-right: 16px;
        }

        ::v-deep .veui-field-messages {
            margin-bottom: -10px;
            min-height: auto;
            padding-top: 4px;
        }

        .id-card {
            ::v-deep .veui-field:not(:last-child) {
                margin-bottom: 14px;
            }
        }

        .isViewModel {
            ::v-deep .veui-field-required > .veui-field-label::before {
                content: "";
                display: none;
            }

            ::v-deep .veui-field-label {
                padding-left: 13px;
                justify-content: flex-start;
            }

            // ::v-deep .veui-field-content {
            //     align-items: center;
            // }
        }

        ::v-deep .veui-field-content {
            font-size: 16px;
            color: #1e1f24;

            .veui-input {
                height: 48px;
                width: @input-width;
                border-radius: 6px;
                border: 1px solid #e9ecf3;
                color: #1e1f24;
                font-size: 16px;
            }

            .veui-select {
                width: @input-width;
            }

            .veui-select-wrap .veui-input {
                height: auto !important;
                min-height: 48px;
            }
        }

        ::v-deep .veui-field-content-wrap {
            align-items: center;
        }

        &:not(:first-child) {
            margin-top: 24px;
        }

        .sub-tip {
            background: #fff;
            border-radius: 6px;
            font-family: PingFang SC;
            font-size: 14px;
            line-height: 1;
            padding: 12px;
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #05f;
            border: none;
            height: 26px;

            &-not {
                border-radius: 6px;
                font-family: PingFang SC;
                padding: 12px;
                position: absolute;
                right: 24px;
                top: 50%;
                transform: translateY(-50%);
                box-sizing: border-box;
                color: #848691 !important;
                border: none;
                background-color: transparent !important;
                font-weight: 400;
                font-size: 14px;
                line-height: 14px;
            }
        }

        .honorary-title,
        .lawyer-position {
            ::v-deep .veui-field-content {
                align-items: center !important;
            }
        }

        .register-philosophy {
            align-items: center;

            ::v-deep .veui-field-content {
                align-items: start;
            }
        }

        .honorary {
            margin-right: 12px;
        }

        .my-radios {
            display: flex;
            margin-top: -5px;

            .radio {
                margin-right: 22px;
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon {
                    position: relative;
                    flex-grow: 0;
                    flex-shrink: 0;
                    border: 1px solid #d3d9e6;
                    background-color: #fff;
                    border-radius: 50%;
                    transition-property: border-color, background-color, box-shadow;
                    transition-duration: .2s;
                    width: 16px;
                    height: 16px;
                    margin-right: 8px;

                    &::before {
                        content: "";
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        background-color: #fff;
                        border-radius: 50%;
                        transform: translate(-50%, -50%) scale(0);
                        transition-property: background-color, transform;
                        transition-duration: .2s;
                        width: 6px;
                        height: 6px;
                    }
                }

                &.selected .icon {
                    border-color: #05f;
                    background-color: #05f;

                    &::before {
                        transform: translate(-50%, -50%) scale(1);
                    }
                }
            }
        }

        .intro {
            width: 600px;
            line-height: 32px;
            margin-bottom: 4px;
        }

        .modify-btn {
            float: right;
            margin-top: -10px;
        }

        ::v-deep .veui-alert {
            margin-bottom: 30px;
            position: relative;
            // height: 50px;
            border-radius: 6px;
            align-items: center;

            &.veui-alert-warning {
                background-color: #faad1414;
            }

            &.veui-alert-titled {
                padding: 14px 12px 14px 26px;
            }

            .veui-alert-content-title {
                font-weight: 400;
                color: #1e1f24;
                margin-bottom: 0;
                width: 865px;
            }
        }

        .show-years {
            margin-left: 40px;
        }

        .show-egister-years {
            margin-left: 10px;
        }

        .card-text {
            font-size: 14px;
            color: #848b99;
            padding-left: 12px;
            font-weight: normal;
        }

        .formname {
            margin-left: 12px;
        }
    }

    ::v-deep .veui-label {
        min-width: 60px;
        color: #1e1f24;
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
    }

    // 只读
    .isViewModel {
        ::v-deep .veui-label {
            color: #848691;
        }
    }

    .gender {
        margin-bottom: 0;
    }

    .is-edit {
        ::v-deep .veui-field-label {
            height: 48px;
        }

        ::v-deep .veui-field {
            &.honorary {
                .veui-uploader-media {
                    max-width: 650px;
                }
            }

            &.graduated-license {
                .veui-uploader-media {
                    max-width: 650px;
                }
            }
        }
    }
}

.mb10 {
    margin-bottom: 10px !important;
}

.mb12 {
    margin-bottom: 12px !important;
}

.mb14 {
    margin-bottom: 14px !important;
}

.mb18 {
    margin-bottom: 18px !important;
}

.mb22 {
    margin-bottom: 22px !important;
}

.mb30 {
    margin-bottom: 30px !important;
}

.authentice .form-href-terms {
    font-size: 14px;
    color: #0052cc;
    cursor: pointer;
}

.authentice .icon {
    width: 16px;
    height: 16px;
    margin-left: 5px;
    position: relative;
    top: 3px;
    cursor: pointer;
}

.agent-protocol-popover {
    /deep/.veui-tooltip {
        max-width: 510px;
    }

    /deep/.veui-tooltip-content {
        margin: 20px;
    }

    .popover-title {
        color: #1e1f24;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 14px;
        line-height: 1;
    }

    .popover-content {
        color: #1e1f24;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 14px;

        .popover-content-image {
            display: flex;

            img {
                width: 229px;
                height: 192px;

                &:first-child {
                    margin-right: 11px;
                }
            }
        }
    }
}

.authentice .form-city {
    line-height: 32px;
}

.authentice .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    color: #1e1f24;
    margin-bottom: 24px;
}

.authentice .exit {
    margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5px;

    .text {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        color: #848691;
        cursor: pointer;
        position: relative;
        text-align: center;
    }

    .text::after {
        content: "";
        position: absolute;
        width: 195px;
        height: 1px;
        background: #848691;
        opacity: .5;
        bottom: -4px;
        left: 0;
    }
}

.authentice .code-upload {
    margin-left: 12px;
}

.authentice ::v-deep .portrait .veui-uploader-input-label-image svg,
.authentice ::v-deep .emblem .veui-uploader-input-label-image svg {
    color: transparent;
    background-size: 100% 100%;
}

// 解决图片闪动问题
.authentice ::v-deep .register .veui-uploader-list-media {
    width: 120px;
    height: 120px;

    .veui-uploader-list-media-item {
        position: absolute;
    }
}

.authentice ::v-deep .portrait .veui-uploader-list-media,
.authentice ::v-deep .emblem .veui-uploader-list-media {
    width: 120px;
    height: 120px;
    margin-right: 12px;

    .veui-uploader-list-media-item {
        position: absolute;
    }
}

.authentice .portrait ::v-deep .veui-uploader-input-label-image svg {
    background: url("../../../assets/img/law/card-portrait.png");
}

.authentice .emblem ::v-deep .veui-uploader-input-label-image svg {
    background: url("../../../assets/img/law/card-emblem.png");
    color: transparent;
    background-size: 100% 100%;
}

.authentice .decs {
    width: 650px;
    color: #848691;
    height: 100%;
    margin-left: 12px;
    position: relative;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.8;
    word-break: break-all;

    &.red {
        color: #ff274b;
    }

    .example {
        color: #05f;
        font-size: 14px;
        cursor: pointer;
        font-weight: 500;
        display: inline-block;
    }

    .pa12 {
        padding-left: 12px;
    }

    .decs-tips {
        margin-top: 10px;
    }

    .show-avatar-btn {
        background: #0054ff14;
        color: #0054ff;
        font-weight: 600;
        font-size: 14px;
        padding: 10px 0;
        width: 187px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        margin-top: 12px;
        cursor: pointer;

        .show-avatar-btn-icon {
            height: 18px;
            width: 18px;
            margin-right: 4px;
            background: url("https://lvlin-fe-saas.bj.bcebos.com/material/xingxing.png") no-repeat center center / 100% 100%;
        }
    }
}

.authentice .licencedecs {
    flex: 1;
}

.authentice .diagram {
    width: 120px;
    height: 120px;
    margin-left: 12px;
    position: relative;
    background: #f5f6f9;
    border-radius: 4px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        display: block;
    }

    .notify {
        position: absolute;
        bottom: 0;
        left: 0;
        background: #848691;
        width: 100%;
        height: 22px;
        line-height: 22px;
        text-align: center;
        border-radius: 0 0 4px 4px;
        color: #fff;
        font-size: 12px;
    }
}

.authentice ::v-deep .textarea {
    display: block;

    textarea {
        width: @input-width;
        height: 100%;
        resize: auto;
        display: block;
    }
}

.form.isViewModel .text ::v-deep .veui-field-main {
    // flex-direction: row;
    margin-top: -5px;
}

.authentice .s-title {
    font-size: 14px;
    color: #000;
    font-weight: 700;
    margin-bottom: 24px;
    padding-top: 16px;
}

.authentice ::v-deep .veui-field-content {
    align-items: start;
    width: 100%;

    .veui-uploader-list-media-container {
        height: 120px;
    }

    .veui-uploader-list-media-item,
    .veui-uploader-list-media-container-upload {
        width: 120px;
    }
}

.identity .identity-image .identity-image-tips {
    text-align: center;
    margin-top: 20px;
    color: #848691;

    &.register-image {
        margin-top: 10px;
    }
}

.authentice .identity .veui-field-no-label {
    margin-left: 0;
}

.register-error {
    color: #d9150b;
    font-size: 12px;
}

.identity {
    .ml12 {
        margin-left: 12px;
    }

    .mr12 {
        margin-right: 12px;
    }

    .register-image-list {
        display: flex;

        /deep/.veui-uploader-list-media {
            margin-left: 0;
            margin-top: -12px;

            .veui-uploader-list-media-item {
                margin-left: 0;
            }
        }
    }

    .register-image-tips {
        text-align: center;
        margin-top: 20px;
        color: #848691;
    }

    .register-image-list-other {
        margin-top: 10px;

        /deep/.veui-uploader-help {
            text-align: center;
            margin-top: 8px;
            color: #848691;
            font-size: 16px;
        }
    }
}

.authentice .position-img {
    ::v-deep .veui-message-error {
        padding-top: 12px;
    }
}

.authentice .veui-field-no-label {
    margin-left: 19px;
}

.authentice .submit-field {
    padding: 30px;
    background: #fff;
    margin-top: 24px;
    border-radius: 8px;
    box-shadow: 0 6px 14px 0 #e3e9ed59;

    .veui-button {
        height: 40px;
        border-radius: 5px;
        padding: 0 24px;
        font-size: 16px;
    }

    .ml15 {
        margin-left: 15px;
    }
}

.authentice .personal-intro ::v-deep .veui-textarea {
    float: left;
    height: 220px;
    width: @input-width;
}

.authentice .personal-intro ::v-deep .veui-field-content {
    align-items: start;
    flex-direction: column;
    max-width: 100%;
}

.authentice .personal-intro .personal_intro-assist {
    margin-top: 10px;
    max-width: 800px;
}

.authentice .ispass ::v-deep .veui-uploader-list-image-mask {
    display: none;

    ::v-deep .veui-uploader {
        display: none;
    }
}

.authentice ::v-deep .ivu-input:focus {
    border-color: #0052cc;
    height: 48px;
    width: @input-width;
}

.authentice ::v-deep .ivu-input {
    height: 48px;
    line-height: 48px;
    width: @input-width;
    border: 1px solid #d3d9e6;
    color: #1e1f24;
    font-size: 16px;
}

.authentice ::v-deep .veui-number-input {
    width: @input-width;

    .veui-input-after {
        display: none;
    }
}

.authentice .honorary ::v-deep .veui-uploader-list-image {
    max-width: 300px;
}

.dialog .circle-icon {
    width: 24px;
}

.dialog .submnit-title {
    font-size: 20px;
}

.viewimg {
    width: 120px;
    max-height: 120px;
    border-radius: 4px;
    background: #f5f6f9;
    object-fit: contain; /* 不压缩、保持比例 */
}

.img-wrapper {
    min-height: 120px;
    display: flex;
    align-items: center;
    margin-right: 12px;
    border: 1px solid #e2e6f0;
    border-radius: 4px;
    float: left;

    .img {
        border: 1px solid #ececec;
        box-sizing: border-box;
        width: 120px;
    }
}

.mult {
    margin-bottom: 12px;
}

::v-deep .veui-field-required-symbol {
    color: #fd503e;
}

.dialog-button {
    width: 128px;
    background-color: #05f;
    margin-left: 50%;
    transform: translateX(-50%);

    &-double {
        width: 128px;
        margin-left: 12px;

        &-first {
            margin-left: 50px;
        }
    }
}

.confirm-submit-dialog ::v-deep .veui-dialog-content {
    border-radius: 8px;
    width: 420px;

    &-foot {
        padding-top: 38px;
    }

    &-head-close {
        color: #000;
    }
}

.confirm-submit-dialog .select-icon {
    width: 18px;
    height: 18px;
    color: #05f;
    vertical-align: text-bottom;
    transform: translateY(-1px);
    margin-right: 4px;
}

.confirm-submit-dialog .quetion-icon {
    width: 14px;
    height: 14px;
    color: #b7b9c1;
    vertical-align: middle;
    transform: translateY(-1px);
    margin-left: 1px;
}

.claim-free-dialog {
    ::v-deep .veui-dialog-content {
        width: 420px;
        border-radius: 8px;
    }

    ::v-deep .veui-dialog-content-foot {
        padding-top: 8px;
    }

    ::v-deep .veui-dialog-content-head-close {
        color: #000;
    }

    .icon-checked {
        width: 14px;
        height: 14px;
        background: url("https://lvlin-base.cdn.bcebos.com/sp-saas/sub-authentice/free-checked.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 3px;
        display: inline-block;
        vertical-align: text-bottom;
        transform: translateY(-3px);
    }

    .icon-not-checked {
        width: 14px;
        height: 14px;
        background: url("https://lvlin-base.cdn.bcebos.com/sp-saas/sub-authentice/free-not-checked.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 3px;
        display: inline-block;
        vertical-align: text-bottom;
        transform: translateY(-3px);
    }

    .quetion-icon {
        vertical-align: middle;
        transform: translateY(-2px);
        width: 12px;
        height: 12px;
        margin-left: -2px;
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/material/icon-question.png") no-repeat;
        background-size: 100% 100%;
        display: inline-block;
    }

    .see-icon {
        width: 14px;
        height: 14px;
        color: #05f;
        vertical-align: middle;
        transform: translateY(-1px);
        margin-left: 1px;
    }

    .see-free-equity {
        display: inline-block;
        font-size: 14px;
        color: #05f;
        margin-left: 50%;
        transform: translate3d(-50%, 0, 0);
        padding-top: 20px !important;
        cursor: pointer;
    }
}

.claim-free-explain-dialog {
    ::v-deep .veui-dialog-content {
        border-radius: 8px;
        width: 840px;
        height: 620px;
    }

    ::v-deep .veui-dialog-content-head {
        background: linear-gradient(180deg, #fff6ec -56.14%, #fff 100%) no-repeat;
        background-size: 100% 57px;
        padding-bottom: 24px;
    }

    ::v-deep .veui-dialog-content-head-close {
        color: #000;
    }

    .explain-dialog-title {
        width: 243.23px;
        height: 33.374px;
        font-family: PingFang SC;
        font-size: 20px;
        color: #773f00;
        background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/material/explain-title-icon.png") no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 33.374px;
        font-weight: 500;
        margin-left: 52%;
        transform: translate3d(-50%, 0, 0);
    }

    ::v-deep .veui-dialog-content-foot {
        display: none;
    }

    ::v-deep .veui-dialog-content-body {
        position: relative;
        overflow: hidden;

        .explain-top {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 63px;
            background: linear-gradient(180deg, #fff 0%, rgba(255, 255, 255,) 93.69%);
        }

        .explain-bottom {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 63px;
            background: linear-gradient(0deg, #fff 23.62%, rgba(255, 255, 255,) 93.69%);
        }
    }

    .explain-body {
        width: 100%;
        height: 516px;
        display: flex;
        overflow-y: scroll;

        .explain-body-img {
            width: 100%;
            height: 548px;
        }
    }
}

.avatar-example {
    /deep/.veui-tooltip {
        width: 514px;
        box-shadow: 0 6px 14px 0 #e3e9ed59;
        border: 1px solid #e9ecf3;
        border-radius: 8px;
        margin-top: 10px;
        max-width: 600px !important;

        .veui-tooltip-content {
            margin: 24px;
        }

        .veui-tooltip-arrow {
            height: 22px;
            width: 22px;

            &::after {
                height: 30px;
                width: 30px;
                top: -18px;
                box-shadow: none;
                border: 1px solid #e9ecf3;
                border-radius: 6px;
            }
        }
    }

    .example-title {
        color: #1e1f24;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 12px;
    }

    .example-item {
        color: #848691;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        line-height: 24px;
    }

    .correct-avatar,
    .error-avatar {
        display: flex;
        align-items: center;
        margin-top: 24px;

        .icon {
            width: 16px;
            height: 16px;
            background: url("https://lvlin-fe-saas.bj.bcebos.com/material/dui.png") no-repeat center / 100% 100%;
            margin-right: 6px;
        }

        .label {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #1e1f24;
        }
    }

    .error-avatar {
        .icon {
            background: url("https://lvlin-fe-saas.bj.bcebos.com/material/cuo.png") no-repeat center / 100% 100%;
        }
    }

    .avatar-box {
        display: flex;
        margin-top: 12px;

        &.not-standardized {
            justify-content: space-between;
        }

        .boy-icon,
        .girl-icon {
            width: 150px;
            height: 150px;
            background: url("https://lvlin-fe-saas.cdn.bcebos.com/material/avatar-biaozhun.png") no-repeat center / 100% 100%;
        }

        .girl-icon {
            margin-left: 20px;
            background: url("https://lvlin-fe-saas.bj.bcebos.com/material/girl.png") no-repeat center / 100% 100%;
        }

        .avatar-icon {
            width: 87px;
            height: 87px;
            background-size: 100% 100%;
            background-repeat: no-repeat;

            &:not(:last-child) {
                margin-right: 8px;
            }
        }

        .avatar-text {
            margin-top: 12px;
            text-align: center;
            color: #1e1f24;
            line-height: 1;
        }
    }
}

.cancel-qualification-dialog {
    ::v-deep .veui-dialog-content-foot {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 24px;
    }

    .cancel-btn {
        width: 181px;
        height: 40px;
        border-radius: 5px;
        background: #05f;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .text {
            font-family: PingFang SC;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
            text-align: center;
            color: #fff;
        }
    }
}

.border-color-red {
    /deep/ .veui-uploader-input-label-media {
        border-color: #f00;
    }
}

.text-color-red {
    color: #f00 !important;
}
</style>
